module.exports = __webpack_public_path__ + "static/media/sales.79cfe2d7.png";